import type { FaireProductEntity } from "../../entity_types/product";

export const p_b4gseerj59: FaireProductEntity = {
  token: "p_b4gseerj59",
  type: "product",
  name: "Healing Stone | Multi Fluorite | Mini Puffy Crystal Hearts",
  brandToken: "b_7ykttxenut",
  brandName: "Soothing Crystals",
  imageUrl:
    "https://cdn.faire.com/fastly/c80ca785134be40450c6a73001d7f3b8d11d9d17d5fbd3623b06dda160b251a3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ca3f8a2ddd80d0d846421c8b70d7408f7ebcd28bd152e4511f75cf325d4876d9.jpeg",
    "https://cdn.faire.com/fastly/8bf07dbc6758beea66428cba7f441db3ec170dec1677bf55c1e47b94432df0ce.jpeg",
    "https://cdn.faire.com/fastly/9f3727c18a7fd563ef5ed09e403cc4588f1649daba65bedd6bd720e79614596b.jpeg",
    "https://cdn.faire.com/fastly/a5081ad342f4cf48e1b4c436f534d49cd30a5dbaeb4e9f28b316db500cf0f271.jpeg",
    "https://cdn.faire.com/fastly/185ea5e3ca4b0fc2eb8ece76ef6c03cdc621221267aaed91955f4c644c271d00.jpeg",
    "https://cdn.faire.com/fastly/d65196eea3546cfa1319fbeb85e4602146536efc1759e63107610e0c6239efe6.jpeg",
    "https://cdn.faire.com/fastly/5e3fc02ac41234468daac03217bc745f2195cbf5559beb48a80d765c6c80219d.jpeg",
    "https://cdn.faire.com/fastly/c52bf1554b8aa1994b62a49e4993adbecef3a220f48788eca5a9640a27180f2d.jpeg",
  ],
  priceDollars: 2.49,
  description:
    '💖Polished premium quality Hearts Crystals made with 100% natural ethically sourced crystal💖\n\nHeart Crystals are symbols of love, healing, and emotional balance. Crafted from natural crystals, they carry powerful spiritual energy. Perfect for meditation, energy work, or meaningful jewelry pieces.\n\n📌Features:\n✔Size of Heart : 1"\n✔Crystal: Multi Fluorite\n\nSoothing Crystals has started a Journey in 2016, to offer high-quality, ethically-sourced crystals to collectors, artists, healers, and seekers from all walks of life.\n\nPeople consider it as: Heart pendant, crystal pendant, healing heart, gemstone heart, heart charm, spiritual pendant, energy stone, or symbolic love crystal.\n\nPerfect for: Boutique gift item, spiritual customers, crystal lovers, gemstone jewelry lovers. wellness boutiques, metaphysical shops, yoga studios, and holistic healers, new age shoppers, boho jewelry fans, energy workers and for crystal collectors.',
  tags: [],
  msrpDollars: 4.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:23.040Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
